import L from "leaflet";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/leaflet.css";
import { useEffect, useMemo, useRef, useState } from "react";
import sateliteViewIcon from "../../../assets/satelite-icon.png";
import streetViewicon from "../../../assets/streetView-icon.png";

import {
    MapContainer,
    Marker,
    Popup,
    TileLayer,
    useMap,
    useMapEvents,
} from "react-leaflet";
import styles from "./MapSelector.module.css";

const defaultIcon = new L.Icon({
    iconUrl: markerIconPng,
    shadowUrl: markerShadowPng,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

function ReturnToMarker({ position, isSatellite }) {
    const [firstZoom, setFirstZoom] = useState(true);
    const map = useMap();

    const handleReturnToMarker = () => {
        if (position) {
            const zoomLevel = map.getZoom();
            map.flyTo(
                position,
                firstZoom ? 10.5 : zoomLevel > 16.5 ? zoomLevel : 16.5
            );
        }
    };

    useEffect(() => {
        const zoomLevel = map.getZoom();
        map.setZoom(zoomLevel - 0.01);
    }, [isSatellite]);

    useEffect(() => {
        handleReturnToMarker();
        setFirstZoom(false);
    }, [position]);
}

export default function MapSelector({
    location,
    setLocation,
    isSatellite,
    setIsSatellite,
}) {
    const [sateliteIsAvailable, setSateliteIsAvailable] = useState(false);

    const initialPosition =
        location && location.position
            ? [location.position.lat, location.position.lng]
            : [45.237425, 13.938222];

    const [position, setPosition] = useState(initialPosition);
    const markerRef = useRef(null);

    useEffect(() => {
        if (initialPosition) {
            setPosition(initialPosition);
        }
    }, [location]);

    const handleMapClick = (e) => {
        changeAddressSelection(e.latlng);
    };

    const changeAddressSelection = async (latlng) => {
        setPosition(latlng);

        setLocation((prevState) => ({
            ...prevState,
            position: {
                lat: latlng.lat,
                lng: latlng.lng,
            },
        }));
    };

    function ClickableMap() {
        useMapEvents({
            click(e) {
                handleMapClick(e);
            },
        });

        return null;
    }

    const eventHandlers = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current;
                if (marker != null) {
                    changeAddressSelection(marker.getLatLng());
                }
            },
        }),
        []
    );

    const checkSatelliteAvailability = async () => {
        try {
            const resp = await fetch(
                "https://api.maptiler.com/maps/satellite/11/1099/737.jpg?key=yPDoroTK11iHh1LiQQUt"
            );

            if (resp.ok) {
                setSateliteIsAvailable(true);
            } else {
                setSateliteIsAvailable(false);
            }
        } catch (err) {
            setSateliteIsAvailable(false);
        }
    };

    useEffect(() => {
        checkSatelliteAvailability();
    }, []);

    return (
        <div className={styles.container}>
            {sateliteIsAvailable && (
                <div
                    className={styles[`map-swicher`]}
                    onClick={() => {
                        setIsSatellite((prevValue) => !prevValue);
                    }}
                >
                    <img
                        className={styles[`map-swicher-image`]}
                        src={isSatellite ? streetViewicon : sateliteViewIcon}
                    />
                </div>
            )}
            <div
                className={`${styles[`map-blur`]} ${
                    location && styles[`map-blur-after`]
                }`}
            />
            <MapContainer
                center={initialPosition} // pazin
                zoom={9}
                doubleClickZoom={false}
                zoomControl={false}
                scrollWheelZoom={true}
            >
                {/*<TileLayer url="https://api.maptiler.com/maps/satellite/{z}/{x}/{y}.jpg?key=yPDoroTK11iHh1LiQQUt" />*/}
                {isSatellite ? (
                    <TileLayer url="https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" />
                ) : (
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                )}
                {position && location && (
                    <Marker
                        draggable={true}
                        position={position}
                        icon={defaultIcon}
                        ref={markerRef}
                        eventHandlers={eventHandlers}
                    ></Marker>
                )}
                <ClickableMap onMapClick={handleMapClick} />
                {position && (
                    <ReturnToMarker
                        isSatellite={isSatellite}
                        position={position}
                    />
                )}
            </MapContainer>
        </div>
    );
}
